import { snapshot, subscribe } from "@core-ui/AppBusy";

const saving = () => (snapshot().counts.save ?? 0) > 0;

/** Resolves once no article edit is waiting to be written, armed debounces included. */
export const whenSaved = (): Promise<void> =>
	new Promise((resolve) => {
		if (!saving()) return resolve();
		const unsubscribe = subscribe(() => {
			if (saving()) return;
			unsubscribe();
			resolve();
		});
	});
